import { inDevEnvironment, inTestEnvironment } from '../util/environment'

if (up.version !== '3.12.0') {
  console.error('Please check, whether you can drop this monkey patch!')
}

// NOTE: This is a polyfill for [up-switch].
// We want [up-switch] to also work when the controlling form field is disabled.

// [up-switch] runs on each state change.
// As the form field is disabled, its state can't change. Therefore, we only run once.
// If you write code that toggles the `disabled` state in JS, this will no longer be sufficient.

up.compiler('input[up-switch][type=checkbox][disabled]', function (checkbox) {
  if (inDevEnvironment() || inTestEnvironment()) {
    console.log('[up-switch] polyfill used')
  }

  const selector = checkbox.getAttribute('up-switch')

  const switchees = checkbox.form.querySelectorAll(selector)
  switchees.forEach((switchee) =>  {
    // CAUTION: we only handle [up-show-for], but not the other switchee variants:
    // [up-hide-for], [up-enable-for], [up-disable-for]
    if (switchee.getAttribute('up-show-for') === '1' && checkbox.value === '1') {

      // CAUTION: we only toggle the visibility, but don't polyfill the full behavior:
      // https://github.com/unpoly/unpoly/blob/master/src/unpoly/classes/switcher.js#L57
      up.element.toggle(switchee, checkbox.checked)
      if (inDevEnvironment()) {
        console.log('[up-switch] polyfill toggled')
      }
    }
  })
})
